import { RealtimeEventScope, RealtimeScope } from "./types";

const KEY_MAP: [keyof RealtimeScope, keyof RealtimeEventScope][] = [
  ["companyId", "company_id"],
  ["portfolioId", "portfolio_id"],
  ["assetId", "asset_id"],
  ["deviceId", "device_id"],
  ["gatewayId", "gateway_id"],
];

export function matchScope(filter: RealtimeScope | undefined, scope: RealtimeEventScope): boolean {
  if (!filter) return true;

  return KEY_MAP.every(([filterKey, eventKey]) => {
    const expected = filter[filterKey];
    const actual = scope[eventKey];
    if (expected === undefined || actual === undefined) return true;
    return expected === actual;
  });
}
